export default __webpack_public_path__ + "static/media/B7.a1dcdd7c.jpeg";